import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';
import { ImgQuery, PictureService } from '../../services';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[osnSharedUseAsPicture]',
})
export class UseAsPictureDirective implements OnChanges {
  @Input() public src: string;
  @Input() public imgQuery: ImgQuery;
  @Input() public param: string;

  private isStructureCreated = false;
  private pictureElement: HTMLPictureElement;

  constructor(
    private readonly pictureService: PictureService,
    private readonly el: ElementRef<HTMLElement>,
    private readonly renderer: Renderer2
  ) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.src?.currentValue !== changes.src?.previousValue) {
      this.createPictureElement();
    }
  }

  private createPictureElement() {
    if (this.isStructureCreated) {
      this.renderer.setAttribute(this.el.nativeElement, 'src', this.src);
      this.pictureElement.childNodes.forEach((node) => {
        if (node.nodeName === 'SOURCE') {
          this.renderer.removeChild(this.pictureElement, node);
        }
      });
      this.createSourceElements();

      return;
    }
    const parentEl = this.el.nativeElement.parentNode;
    this.pictureElement = this.renderer.createElement('picture');
    parentEl.replaceChild(this.pictureElement, this.el.nativeElement);
    this.renderer.appendChild(this.pictureElement, this.el.nativeElement);
    this.renderer.setAttribute(this.el.nativeElement, 'src', this.src);
    this.renderer.removeChild(parentEl, this.el);
    this.createSourceElements();
    this.isStructureCreated = true;
  }

  private createSourceElements() {
    this.pictureService.getImgSourcesForMpxImage(this.src, this.imgQuery, this.param).forEach((img) => {
      const sourceEl = this.renderer.createElement('source');
      this.renderer.setAttribute(sourceEl, 'media', img.media);
      this.renderer.setAttribute(sourceEl, 'srcset', img.srcset);
      this.renderer.insertBefore(this.pictureElement, sourceEl, this.el.nativeElement);
    });
  }
}
